import { Action } from '@ngrx/store';

export enum ClearStateType {
  ClearState = 'clearState',
}

export class ClearState implements Action {
  readonly type = ClearStateType.ClearState;
}
